import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		init: false,
		sendCloud: null,
	},
	getters: {
		sendCloud(state) {
			return state.sendCloud;
		},
		shippingOptions(state) {
			if (state.sendCloud !== null && state.sendCloud.shipping_options !== null) {
				return state.sendCloud.shipping_options;
			}

			return null;
		},
	},
	mutations: {
		SET_SENDCLOUD(state, sendCloud) {
			state.sendCloud = sendCloud;
		},
		SET_INIT(state, init) {
			state.init = init;
		},
		CLEAR_STORE(state) {
			state.init = null;
			state.sendCloud = null;
		}
	},
	actions: {
		init({commit, state}) {
			return new Promise((resolve, reject) => {
				if (state.init) {
					resolve();
				} else {
					apiClient.get('settings/sendcloud/get').then(res => {
						commit('SET_SENDCLOUD', res.data);
						commit('SET_INIT', true);
						resolve();
					}).catch(err => {
						reject(err);
					});
				}
			});
		},
		createSendCloud({commit}, submitCredentials) {
			return new Promise((resolve, reject) => {
				commit('SET_INIT', false);
				apiClient.post('settings/sendcloud/create', submitCredentials).then(res => {
					commit('SET_SENDCLOUD', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				});
			});
		},
		updateSippingOptions({commit}, selectedUpdate) {
			const params = {
				enabled: selectedUpdate.enabled,
				shipping_option_id: selectedUpdate.sendcloudShippingOptionId,
			};
			return new Promise((resolve, reject) => {
				apiClient.put('settings/sendcloud/update', params).then(res => {
					commit('SET_INIT', false);
					resolve();
				}).catch(err => {
					reject(err);
				});
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}